import React, {useState} from 'react';

import './ProfileCompany.scss';
import { useTranslation } from 'react-i18next';

const ProfilePlansFailure = () => {
  const {t} = useTranslation();

  return (
    <div className='zestur-card'>
      <h2 className='general-heading mt-4 mb-4'>{t('planPage.failureheading')}</h2>
      <p>{t('planPage.failurebody')}</p>
      <p>&nbsp;</p>
    </div>
  );
};

export default ProfilePlansFailure;
